import React, { useState, useRef, useEffect } from 'react';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [instituteOpen, setInstituteOpen] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);
  const [mobileInstituteOpen, setMobileInstituteOpen] = useState(false);
  const [mobileMoreOpen, setMobileMoreOpen] = useState(false);

  const navbarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setInstituteOpen(false);
        setMoreOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleInstitute = () => {
    setInstituteOpen(!instituteOpen);
    setMoreOpen(false);
  };

  const toggleMore = () => {
    setMoreOpen(!moreOpen);
    setInstituteOpen(false);
  };

  const toggleMobileInstitute = () => {
    setMobileInstituteOpen(!mobileInstituteOpen);
    setMobileMoreOpen(false);
  };

  const toggleMobileMore = () => {
    setMobileMoreOpen(!mobileMoreOpen);
    setMobileInstituteOpen(false);
  };

  const NavLink = ({ href, children }) => (
    <a
      href={href}
      className="relative group px-3 py-2 text-sm font-medium text-white transition-colors duration-200"
    >
      <span className="relative z-10">{children}</span>
      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-500 group-hover:w-full transition-all duration-300 ease-out"></span>
    </a>
  );

  const NavDropdown = ({ label, isOpen, onClick, children }) => (
    <div className="relative">
      <button
        onClick={onClick}
        className="relative group px-3 py-2 text-sm font-medium text-white transition-colors duration-200 flex items-center space-x-1"
      >
        <span className="relative z-10">{label}</span>
        <svg
          className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
        <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-500 group-hover:w-full transition-all duration-300 ease-out"></span>
      </button>
      {children}
    </div>
  );

  return (
    <nav ref={navbarRef} className="bg-blue-950 sticky top-0 z-50 font-sans">
      <div className="max-w-screen-3xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16">
          <div className="flex-shrink-0 flex items-center">
            <img
              src="/rds logo.png"
              alt="RDS Logo"
              className="h-16 w-auto object-contain"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
          <div className="hidden md:flex flex-1 items-center justify-center">
            <div className="flex space-x-1">
              <NavLink href="/">Home</NavLink>
              <NavLink href="about">About Us</NavLink>

              <NavDropdown label="Institute" isOpen={instituteOpen} onClick={toggleInstitute}>
                <div
                  className={`absolute left-0 mt-2 w-72 bg-white rounded-lg shadow-xl py-2 border border-gray-100 transition-all duration-200 ${
                    instituteOpen
                      ? 'opacity-100 visible translate-y-0'
                      : 'opacity-0 invisible -translate-y-2'
                  }`}
                >
                  <a
                    href="https://rdspharmacy.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block px-4 py-2.5 text-sm text-gray-800 hover:bg-orange-100 hover:text-orange-700 transition-colors"
                  >
                    R D S College of Pharmacy
                  </a>
                  <a
                    href="https://paramedical.rdsgroupofcolleges.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block px-4 py-2.5 text-sm text-gray-800 hover:bg-orange-100 hover:text-orange-700 transition-colors"
                  >
                    R D S Nursing and Paramedical College
                  </a>
                  <a
                    href="https://mahavidyalaya.rdsgroupofcolleges.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block px-4 py-2.5 text-sm text-gray-800 hover:bg-orange-100 hover:text-orange-700 transition-colors leading-tight"
                  >
                    R.D.S. Mahavidyalaya Affiliated (Veer Bahadur Singh Purvanchal University, Jaunpur)
                  </a>
                  <a
                    href="https://iti.rdsgroupofcolleges.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block px-4 py-2.5 text-sm text-gray-800 hover:bg-orange-100 hover:text-orange-700 transition-colors"
                  >
                    Sharda Private ITI
                  </a>
                </div>
              </NavDropdown>

              <NavLink href="admission">Admissions</NavLink>
              <NavLink href="results">Result</NavLink>

              <NavDropdown label="More" isOpen={moreOpen} onClick={toggleMore}>
                <div
                  className={`absolute left-0 mt-2 w-56 bg-white rounded-lg shadow-xl py-2 border border-gray-100 transition-all duration-200 ${
                    moreOpen
                      ? 'opacity-100 visible translate-y-0'
                      : 'opacity-0 invisible -translate-y-2'
                  }`}
                >
                  <a href="research" className="block px-4 py-2.5 text-sm text-gray-800 hover:bg-orange-100 hover:text-orange-700 transition-colors">
                    Research and Development
                  </a>
                  <a href="contact" className="block px-4 py-2.5 text-sm text-gray-800 hover:bg-orange-100 hover:text-orange-700 transition-colors">
                    Contact us
                  </a>
                </div>
              </NavDropdown>
            </div>
          </div>

          <div className="hidden md:flex items-center space-x-3">
            {/* Social icons - unchanged */}
            <a href="#" className="text-white hover:text-orange-500 transition-colors" aria-label="Facebook">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"/>
              </svg>
            </a>
            <a href="#" className="text-white hover:text-orange-500 transition-colors" aria-label="Twitter">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"/>
              </svg>
            </a>
            <a href="#" className="text-white hover:text-orange-500 transition-colors" aria-label="Instagram">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z"/>
              </svg>
            </a>
            <a href="#" className="text-white hover:text-orange-500 transition-colors" aria-label="YouTube">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </a>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="p-2 rounded-md text-white hover:bg-orange-700 transition-colors focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden transition-all duration-300 ease-in-out overflow-hidden ${
          mobileMenuOpen ? 'max-h-screen' : 'max-h-0'
        }`}
      >
        <div className="px-4 pt-2 pb-4 space-y-1 bg-blue-800">
          <a href="/" className="block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-orange-700 transition-colors">
            Home
          </a>
          <a href="about" className="block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-orange-700 transition-colors">
            About Us
          </a>
          <div>
            <button
              onClick={toggleMobileInstitute}
              className="w-full flex justify-between items-center px-3 py-2 rounded-md text-base font-medium text-white hover:bg-orange-700 transition-colors"
            >
              <span>Institute</span>
              <svg className={`w-5 h-5 transition-transform duration-200 ${mobileInstituteOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            <div
              className={`mt-2 ml-4 space-y-1 overflow-hidden transition-all duration-200 ${
                mobileInstituteOpen ? 'max-h-96' : 'max-h-0'
              }`}
            >
              <a
                href="https://pharmacy.rdsgroupofcolleges.com"
                target="_blank"
                rel="noopener noreferrer"
                className="block px-3 py-2 rounded-md text-sm text-white bg-blue-700 hover:bg-orange-700 transition-colors"
              >
                R D S College of Pharmacy
              </a>
              <a
                href="https://paramedical.rdsgroupofcolleges.com"
                target="_blank"
                rel="noopener noreferrer"
                className="block px-3 py-2 rounded-md text-sm text-white bg-blue-700 hover:bg-orange-700 transition-colors"
              >
                R D S Nursing and Paramedical College
              </a>
              <a
                href="https://mahavidyalaya.rdsgroupofcolleges.com"
                target="_blank"
                rel="noopener noreferrer"
                className="block px-3 py-2 rounded-md text-sm text-white bg-blue-700 hover:bg-orange-700 transition-colors leading-tight"
              >
                R.D.S. Mahavidyalaya Affiliated (Veer Bahadur Singh Purvanchal University, Jaunpur)
              </a>
              <a
                href="https://iti.rdsgroupofcolleges.com"
                target="_blank"
                rel="noopener noreferrer"
                className="block px-3 py-2 rounded-md text-sm text-white bg-blue-700 hover:bg-orange-700 transition-colors"
              >
                Sharda Private ITI
              </a>
            </div>
          </div>

          <a href="admission" className="block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-orange-700 transition-colors">
            Admissions
          </a>
          <a href="results" className="block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-orange-700 transition-colors">
            Result
          </a>
          <div>
            <button
              onClick={toggleMobileMore}
              className="w-full flex justify-between items-center px-3 py-2 rounded-md text-base font-medium text-white hover:bg-orange-700 transition-colors"
            >
              <span>More</span>
              <svg className={`w-5 h-5 transition-transform duration-200 ${mobileMoreOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            <div
              className={`mt-2 ml-4 space-y-1 overflow-hidden transition-all duration-200 ${
                mobileMoreOpen ? 'max-h-96' : 'max-h-0'
              }`}
            >
              <a href="research" className="block px-3 py-2 rounded-md text-sm text-white bg-blue-700 hover:bg-orange-700 transition-colors">
                Research and Development
              </a>
              <a href="contact" className="block px-3 py-2 rounded-md text-sm text-white bg-blue-700 hover:bg-orange-700 transition-colors">
                Contact us
              </a>
            </div>
          </div>
          <div className="flex space-x-4 pt-4">
            {/* Social icons for mobile - same as desktop */}
            <a href="#" className="text-white hover:text-orange-500 transition-colors" aria-label="Facebook">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"/></svg>
            </a>
            <a href="#" className="text-white hover:text-orange-500 transition-colors" aria-label="Twitter">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"/></svg>
            </a>
            <a href="#" className="text-white hover:text-orange-500 transition-colors" aria-label="Instagram">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z"/></svg>
            </a>
            <a href="#" className="text-white hover:text-orange-500 transition-colors" aria-label="YouTube">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;